import React, { useEffect, useRef, useState } from "react";
import TripleDotOption from "../../assets/svg/TripleDotOption";
import axiosPrivate from "../../axios/axiosPrivate";
import useLoader from "../../hooks/useLoader";
import useAuth from "../../hooks/useAuth";

const SingleAddressDetail = ({ address, mt, onClose, onEdit }) => {
  const { setLoading } = useLoader(); // normal loader for action
  const { setUser } = useAuth();
  const menuRef = useRef(null);
  const [open, setOpen] = useState(false);

  const setDefaultAddress = async () => {
    try {
      onClose();
      setLoading(true);

      const response = await axiosPrivate.put("/address/set-default-address", {
        address_id: address.id,
      });
      const newDefaultId = response?.data?.data?.id;
      setUser((prev) => ({
        ...prev,
        addresses: prev.addresses.map((addr) => ({
          ...addr,
          default: addr.id === newDefaultId,
        })),
      }));
    } catch (error) {
      console.log("Error setting default address");
    } finally {
      setLoading(false);
    }
  };

  const handleMenuToggle = (e) => {
    e.stopPropagation();
    setOpen((prev) => !prev);
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    setOpen(false);
    onEdit && onEdit();
  };

  const handleDelete = async (e) => {
    try {
      e.stopPropagation();
      setOpen(false);
      setLoading(true);

      const response = await axiosPrivate.delete("/address/delete-address", {
        data: { address_id: address?.id },
      });

      const deletedId = response?.data?.data?.id;

      setUser((prev) => ({
        ...prev,
        addresses: prev.addresses.filter((addr) => addr.id !== deletedId),
      }));
    } catch (error) {
      console.log("Error deleting address");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const handler = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div
      className={`bg-white p-4 rounded-lg shadow-sm border border-[#00000010] ${mt} ${
        !address?.default && "cursor-pointer"
      } flex items-start justify-between gap-2`}
      onClick={() => {
        if (!address?.default) {
          setDefaultAddress();
        }
      }}
    >
      <div>
        {address?.default ? (
          <div className="w-4 h-4 rounded-full border-[4px] border-blue-500" />
        ) : (
          <div className="w-4 h-4 rounded-full border-2 border-gray-300" />
        )}
      </div>
      <div className="flex-1">
        <p className="general-sans-medium text-[16px]">{address?.name}</p>
        <p className="general-sans-regular text-[14px] mt-2 leading-[20px] tracking-wide">
          {address?.address1 +
            " " +
            address?.address2 +
            ", " +
            address?.city +
            " " +
            address?.province +
            ", " +
            address?.zip}
        </p>
      </div>
      <div className="relative" ref={menuRef}>
        {address?.default ? null : (
          <button
            onClick={handleMenuToggle}
            className="p-1 rounded-full hover:bg-gray-100"
          >
            <TripleDotOption className="w-5 h-5 text-gray-600" />
          </button>
        )}

        {open && (
          <div className="absolute right-0 top-8 w-32 bg-white rounded-lg shadow-lg border border-black/10 z-20">
            <button
              className="w-full text-left px-4 py-2 text-sm hover:bg-gray-100 general-sans-medium"
              onClick={handleEdit}
            >
              Edit
            </button>
            <button
              className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100 general-sans-medium"
              onClick={handleDelete}
            >
              Delete
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SingleAddressDetail;
